<template>
  <div class="examination">
    <div class="header">
      <div class="solid-btn" style="--bgc: #ffb842; --bsc: #c0811f;" @mouseup="leavebtn">{{ $t("studentProgramme.leave") }}</div>
      <span class="title"> {{ getType() == 'library' ? questionInfo.desc || '' : questionInfo.number }}</span>
      <span class="empty"></span>
    </div>

    <div class="container">
      <div class="question-nav" tabindex="1" @touchstart.self="questionFocus" ref="question">
        <div class="question-box" v-if="mode == 'question'">
          <div :class="['circle',
            item.status == '1' && 'cur-answer',
            item.status == '2' && 'use-answer']"
               v-for="(item, idx) in questionList" :key="idx" @click="clickTopic(idx)">{{ item.key }}</div>
        </div>
        <div class="question-box" v-else>
          <div :class="['result',
              item.true_flase == 'success' ? 'success' : 'error',
              idx == curQuestion && 'cur-result']"
               v-for="(item, idx) in questionList" :key="idx" @click="clickTopic(idx)">{{ item.key }}</div>
        </div>
      </div>

      <div class="quesion-main" @click.prevent="">
        <div class="main" :style="`height: ${isPC() && '100%'};`">
          <div class="main-header">
            <div class="left">
              <div class="topic">{{ $t("studentProgramme.question") }}{{ curQuestion + 1 }}/{{questionList.length}}</div>
              <div class="tip">
                {{ getQuestionTypeLabel(form.type) }}
              </div>
              <div class="question-no">{{ $t("studentProgramme.questionNo") }}{{ form && form.question_no }}</div>
            </div>
            <div v-if="mode == 'viewAnswer'"></div>
          </div>

          <div class="body" v-if="form"
               v-loading="loading" element-loading-background="#fff" element-loading-text="Loading"
               :style="`${mode == 'viewAnswer' ? `--beforeShow: '';` : `--beforeShow: none;`} ${isPC() ? 'flex: 1;' : ''}`"
               tabindex="2" @touchstart.self="bodyFocus" ref="body" @scroll="checkScroll">
            <div class="before" v-if="loading"></div>
            <ChoiceEcho ref="ChoiceEcho" @repariRecordQuestion="repariRecordQuestion" @urlToParent="urlToParent" @permissions="permissions" v-if="form.type == 0" :mode="mode" :form="form" :key="form.id"></ChoiceEcho>
            <DetermineEcho ref="DetermineEcho" @repariRecordQuestion="repariRecordQuestion" @urlToParent="urlToParent" @permissions="permissions" v-else-if="form.type == 1" :mode="mode"  :form="form" :key="form.id"></DetermineEcho>
            <FillingBlanksEcho ref="FillingBlanksEcho" @repariRecordQuestion="repariRecordQuestion" @urlToParent="urlToParent" @permissions="permissions" v-else-if="form.type == 2" :mode="mode"  :form="form" :key="form.id"></FillingBlanksEcho>
            <MatrimFillEcho ref="MatrimFillEcho" @repariRecordQuestion="repariRecordQuestion" @urlToParent="urlToParent" @permissions="permissions" v-else-if="form.type == 10" :mode="mode"  :form="form" :key="form.id"></MatrimFillEcho>
            <SumEcho ref="SumEcho" @repariRecordQuestion="repariRecordQuestion" @permissions="permissions" v-else-if="form.type == 3 || form.type == 8" :mode="mode"  :form="form" :key="form.id"></SumEcho>
            <HotspotEcho ref="HotspotEcho" @repariRecordQuestion="repariRecordQuestion" @permissions="permissions" v-else-if="form.type == 4" :mode="mode"  :form="form" :key="form.id"></HotspotEcho>
            <TextDragEcho ref="TextDragEcho" @repariRecordQuestion="repariRecordQuestion" @permissions="permissions" v-else-if="form.type == 5" :mode="mode"  :form="form" :key="form.id"></TextDragEcho>
            <LigatureEcho ref="LigatureEcho" @repariRecordQuestion="repariRecordQuestion" @permissions="permissions" v-else-if="form.type == 6" :mode="mode"  :form="form" :key="form.id"></LigatureEcho>
            <ImgDragEcho ref="ImgDragEcho" @repariRecordQuestion="repariRecordQuestion" @permissions="permissions" v-else-if="form.type == 7" :mode="mode"  :form="form" :key="form.id"></ImgDragEcho>
            <TextDragEcho2 ref="TextDragEcho2" @repariRecordQuestion="repariRecordQuestion" @permissions="permissions" v-else-if="form.type == 9" :mode="mode"  :form="form" :key="form.id"></TextDragEcho2>

            <div class="more-prompt" v-if="showMorePrompt">
              <img v-if="showMoreImg" src="@/assets/images/more.svg" @click="checkScroll" style="height: 60px;">
            </div>
            <div class="up-down" v-if="showMorePrompt" style="display: flex; flex-direction: column; gap: 8px;">
              <!-- 上滚 -->
              <img src="@/assets/images/up.svg" @click="scrollUp" style="height: 60px;">
              <!-- 下滚 -->
              <img src="@/assets/images/down.svg" @click="scrollDown" style="height: 60px;">
            </div>
          </div>

          <div class="viewAnswer-func">
            <div class="viewAnswer-func" style="justify-content: left;">
              <div class="solid-btn disabled" v-if="curQuestion < (questionList.length - 1) && nextQuestionSwitch && mode == 'question'" style="--bgc:#dcdbdc; --bsc: #979797; --textc: #9b9b9b">{{ $t("studentProgramme.skip") }}</div>
              <div class="solid-btn" style="--bgc:#ffb842; --bsc: #c0811f;"
                   v-else-if="curQuestion < (questionList.length - 1) && mode == 'question'" @click="skip">{{ $t("studentProgramme.skip") }}</div>
              <div class="solid-btn disabled" v-if="!nextQuestionSwitch && mode == 'question'" style="--bgc:#dcdbdc; --bsc: #979797; --textc: #9b9b9b">{{ $t("studentProgramme.reset") }}</div>
              <div class="solid-btn" style="--bgc:#ffb842; --bsc: #c0811f;"
                   v-else-if="mode == 'question'" @click="resetting">{{ $t("studentProgramme.reset") }}</div>
              <div class="solid-btn disabled" v-if="curQuestion < (questionList.length - 1) && !nextQuestionSwitch" style="--bgc:#dcdbdc; --bsc: #979797; --textc: #9b9b9b">{{ $t("studentProgramme.nextQuestion") }}</div>
              <div class="solid-btn" style="--bgc:#ffb842; --bsc: #c0811f;"
                   v-else-if="curQuestion < (questionList.length - 1)" @click="nextQuestion">{{ $t("studentProgramme.nextQuestion") }}</div>
              <div class="solid-btn" style="--bgc:#ffb842; --bsc: #c0811f;" v-if="curQuestion != 0 && mode == 'viewAnswer'" @click="prevQuestion">{{ $t("studentProgramme.previousQuestion") }}</div>

              <div class="solid-btn" style="--bgc:#ea6f57; --bsc: #c15230; --textc: #fff"
                   :class="{ 'loading': isLoading }"
                   :disabled="isLoading"
                   v-if="curQuestion == (questionList.length - 1) && mode == 'question'" @click="completeBefore()">{{ isLoading ? $t("studentProgramme.submit")+'...' : $t("studentProgramme.finish") }}</div>
              <div class="solid-btn" style="--bgc:#ffb842; --bsc: #c0811f;" @click="toggleDrawingBoard">✏️</div>
              <DrawingBoard :visible="showDrawingBoard" @close="showDrawingBoard = false" />
            </div>

            <div class="viewAnswer-func" v-if="mode == 'viewAnswer'" style="justify-content: right;">
              <div class="reference">
                <div class="solid-btn" v-if="form.explanation" style="--bgc:#ffb842; --bsc: #c0811f;" @click="showAnswering">{{ $t("studentProgramme.solutionApproach") }}</div>
                <div class="empty" v-else></div>
                <div class="solid-btn" style="--bgc:#ffb842; --bsc: #c0811f;" @click="showReference">{{ $t("studentProgramme.answers") }}</div>
              </div>
              <div class="solid-btn" style="--bgc:#ffb842; --bsc: #c0811f;" @click="showIssues">{{ $t("studentProgramme.issue") }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <LeaveDialog @closeDialog="leaveSwitch = false" :mode="mode" :leaveMessage="leaveMessage" v-if="leaveSwitch"></LeaveDialog>
    <TipsDialog @closeDialog="tipsSwitch = false" @confrim="tipsConfrim" message="The answer must be a number." v-if="tipsSwitch"></TipsDialog>
    <ConfirmSubmit @closeDialog="confrimSwitch = false" @confirm="complete" v-if="confrimSwitch"></ConfirmSubmit>
    <AnsweringDialog :explanation="form.explanation" @closeDialog="answeringSwitch = false" v-if="answeringSwitch"></AnsweringDialog>
    <IssuesDialog :id="form.id" @closeDialog="issuesSwitch = false" v-if="issuesSwitch"></IssuesDialog>
    <QuizDialog v-if="false"></QuizDialog>
    <ShowBigPhoto v-if="showBigPhotoSwitch" :url="imageUrl" @close="closeShowBigPhoto"></ShowBigPhoto>
    <DialogPreview v-if="referenceSwitch" :form="form" @close="referenceSwitch = false" :recordData="recordQuestionList[curQuestion]"></DialogPreview>
    <Complete :answerResults="answerResults" :mode="mode" @close="viewAnswer" v-if="completeSwitch"></Complete>
  </div>
</template>

<script>
import IScroll from 'iscroll/build/iscroll-probe.js'
import { _throttle } from '../../utils/throttle.js'
import transform from './static/transition.js'
import { getAssessments, putAssessmentsAnswer } from '@/api/assessment.js'
import { getHomeworksDetail, putHomeworksAnswer } from '@/api/homework.js'
import { putPractisesAnswer, getPractisesDetail } from '@/api/practise.js'
import { putTopicsAnswer, getTopicsTest } from '@/api/topic.js'
import { toSnakeCase } from '@/utils/data-format.js'
import { getChildOffsetRelativeToParent } from '@/utils/scroll-to.js'
import answersTrueFalse from './static/answersTrueFlase.js'
import EventBus from './static/event-bus.js'
import DrawingBoard from '@/views/examination/components/DrawingBoard';
import { getUserInfo } from "@/utils/auth";
import { getAnswerToRedis, saveAnswerToRedis,delAnswerRedis } from "@/api/answerResult";

let clickQuestThrottle = null, intervalTime = 1000

export default {
  components: { ...transform, DrawingBoard },
  data() {
    return {
      showDrawingBoard: false,
      isSmallTest: false,
      isLoading: false,
      showMorePrompt: false,
      showMoreImg: false, // 新增：标记是否已经出现过提示
      convertType: ['ChoiceEcho','DetermineEcho','FillingBlanksEcho','SumEcho','HotspotEcho','TextDragEcho','LigatureEcho','ImgDragEcho','SumEcho','TextDragEcho2','MatrimFillEcho'],
      questionList: [],
      questionInfo: {},
      mode: 'question',
      echo: 'FillingBlanksEcho',
      curQuestion: 0,
      form: null,
      questionTypes:[
        { label: this.$t("studentProgramme.choiceQuestion"), value: 0 },
        { label: this.$t("studentProgramme.judgeQuestion"), value: 1 },
        { label: this.$t("studentProgramme.fillBlankQuestion"), value: 2 },
        { label: this.$t("studentProgramme.arithmeticFixedQuestion"), value: 3 },
        { label: this.$t("studentProgramme.hotspotQuestion"), value: 4 },
        { label: this.$t("studentProgramme.textDragQuestion"), value: 5 },
        { label: this.$t("studentProgramme.connectionQuestion"), value: 6 },
        { label: this.$t("studentProgramme.imageDragQuestion"), value: 7 },
        { label: this.$t("studentProgramme.arithmeticVariableQuestion"), value: 8 },
        { label: this.$t("studentProgramme.textDragClassifyQuestion"), value: 9 },
        { label: this.$t("studentProgramme.matrixFillQuestion"), value: 10 }
      ],
      imageUrl: '',
      leaveMessage: '',
      leaveSwitch: false, tipsSwitch: false, confrimSwitch: false, answeringSwitch: false,
      issuesSwitch: false, completeSwitch: false, nextQuestionSwitch: false, showBigPhotoSwitch: false, referenceSwitch: false,
      nextStatus: null, isClickNext: false,
      results: { topic_id: null, answer_results: [] },
      recordQuestionList: [],
      fillExistNotNumber: { methods: '', parmas: null, isSkip: false },
      answerResults: null, iscroll: null, loading: true,
      userId: getUserInfo("userProfile").id,
      isCompleted: false,
    }
  },
  watch: {
    curQuestion() { this.curQuestionNumberTop() },
    nextStatus() { if(this.nextStatus === true && this.isClickNext === true) this.nextQuestion() }
  },
  methods: {
    saveAnswerCache() {
      if (this.isCompleted) return;

      // ==============================================
      // 核心：自动补齐 answer_results，严格按 answers 长度生成
      // ==============================================
      const fullAnswers = [];

      this.questionList.forEach(q => {
        const qid = q.id;
        const type = q.type;
        const answers = q.answers || [];

        // 1. 过滤 answers：排除 choice_id = 0
        const validAnswers = answers.filter(item => item.choice_id !== 0);
        const answerLength = validAnswers.length; // 你要的长度

        // 2. 取出学生已有的答案
        let studentItem = this.results.answer_results.find(res => res.id === qid);
        let studentChoices = studentItem ? [...studentItem.student_choices] : [];

        // 3. 拖拽题 type=5 / type=9 / type=10：自动补齐空选项，保证长度一致
        if ([5].includes(type)) {
          validAnswers.forEach(validAns => {
            const exist = studentChoices.some(c => c.choice_id === validAns.choice_id);
            if (!exist) {
              studentChoices.push({
                choice_id: validAns.choice_id,
                value: "[]"
              });
            }
          });
          // 严格截断，保证长度 = 有效答案长度
          studentChoices = studentChoices.slice(0, answerLength);
        }

        // 4. 推入最终结构
        fullAnswers.push({
          id: qid,
          student_choices: studentChoices
        });
      });

      // 覆盖回 results
      this.results.answer_results = fullAnswers;

      const cacheData = {
        questionList: JSON.parse(JSON.stringify(this.questionList)), // 深拷贝
        recordQuestionList: JSON.stringify(this.recordQuestionList), // ✅ 存：字符串
        results: JSON.parse(JSON.stringify(this.results)),           // 深拷贝
        curQuestion: this.curQuestion,
        cacheKey: this.getCacheKey()
      }

      saveAnswerToRedis(cacheData).then().catch(err => console.log('缓存保存失败', err))
    },
    saveAnswerCache2() {
      if (this.isCompleted) return;

      const cacheData = {
        questionList: JSON.parse(JSON.stringify(this.questionList)), // 深拷贝
        recordQuestionList: JSON.stringify(this.recordQuestionList), // ✅ 存：字符串
        results: JSON.parse(JSON.stringify(this.results)),           // 深拷贝
        curQuestion: this.curQuestion,
        cacheKey: this.getCacheKey()
      }

      saveAnswerToRedis(cacheData).then().catch(err => console.log('缓存保存失败', err))
    },
    async loadAllCache() {
      try {
        const params = { cacheKey: this.getCacheKey() }
        const res = await getAnswerToRedis(params)
        const data = res.data
        if (!data) return

        // 1. 恢复题目列表
        if (data.questionList && data.questionList.length) {
          this.questionList = data.questionList
        }

        // 2. 恢复答题记录 ✅ 取：必须 JSON.parse
        if (data.recordQuestionList) {
          this.recordQuestionList = JSON.parse(data.recordQuestionList)
        }

        // 3. 恢复答案结果
        if (data.results) {
          this.results = data.results
        }

        // 4. 恢复当前题号
        if (data.curQuestion !== undefined) {
          this.curQuestion = data.curQuestion
        }

        // 5. 恢复当前题目
        if (this.questionList.length) {
          this.form = JSON.parse(JSON.stringify(this.questionList[this.curQuestion]))
          this.nextQuestionSwitch = this.mode !== 'question' || (this.form.limit > 0)
        }

        this.loading = false
      } catch (err) {
        console.log('❌ 缓存读取失败', err)
        this.loading = false
      }
    },
    getStudentAnswer() {
      const echo = this.convertType[this.form.type]
      const child = this.$refs[echo]
      child.answer_results.id = this.form.id
      this.questionList[this.curQuestion].status = child.limit > 0 ? '2' : '0'
      this.questionList[this.curQuestion].limit = child.limit;
      this.recordQuestionList[this.curQuestion] = JSON.parse(JSON.stringify(child.recordQuestion))
      this.results.answer_results[this.curQuestion] = child.answer_results
      const res = answersTrueFalse(child.recordQuestion, child.answer_results, this.form)
      this.questionList[this.curQuestion].true_flase = res ? 'success' : 'error'
      this.saveAnswerCache()
    },
    getCacheKey() {
      return `quiz_cache_${this.$route.query.type}_${this.$route.query.id}_${this.$route.query.topicId}_${this.userId}`
    },
    clearAnswerCache() {
      // 同时清理 localStorage + redis 标记
      const params = { cacheKey: this.getCacheKey() }
      delAnswerRedis(params)
      // 提交后不再写缓存
      this.isCompleted = true;
    },

    // ====================== 載入答案到組件【終極防串題】 ======================
    loadCachedAnswerToComponent() {
      this.$nextTick(() => {
        if (!this.form || !this.$refs) return;
        const type = this.form.type;
        const componentName = this.convertType[type];
        const child = this.$refs[componentName];
        const cache = this.recordQuestionList[this.curQuestion];
        if (!child || !cache) return;
        if (this.form.id !== this.form.id) return;
        child.recordQuestion = JSON.parse(JSON.stringify(cache));
        child.limit = this.form.limit || 0;
        child.answer_results = this.results.answer_results[this.curQuestion];
      });
    },

    readText() {
      window.speechSynthesis.cancel();
      let text = document.querySelector(".body").innerText.replace(/^[\s\S]{5}/, '').trim().replace('Loading', '');
      const utterance = new SpeechSynthesisUtterance(text);
      utterance.lang = 'zh-HK'; utterance.rate = 1; utterance.volume = 1;
      window.speechSynthesis.speak(utterance);
    },
    getQuestionTypeLabel(value) {
      const item = this.questionTypes.find(i => i.value === value);
      return item ? item.label : ""
    },
    verifyFillExist() {
      if (this.form.type == 2) {
        const echo = this.convertType[this.form.type]
        const child = this.$refs[echo]
        this.tipsSwitch = child.verifyFillExist()
        return this.tipsSwitch
      }
      return false
    },
    tipsConfrim() {
      this.fillExistNotNumber.isSkip = true
      if (this.fillExistNotNumber.methods == 'clickTopic') this.clickTopic(this.fillExistNotNumber.parmas)
      else if (this.fillExistNotNumber.methods == 'nextQuestion') this.nextQuestion()
      this.fillExistNotNumber = { methods: '', parmas: null, isSkip: false }
      this.tipsSwitch = false
    },
    leavebtn() {
      this.leaveMessage = this.mode == 'question' ? this.$t("studentProgramme.leaveText") : ''
      this.leaveSwitch = true
    },
    questionFocus() { this.$refs.question.focus() },
    bodyFocus() { this.$refs.body.focus() },
    isPC() {
      const userAgent = navigator.userAgent.toLowerCase();
      return !(userAgent.indexOf('ipad') > -1 || (userAgent.indexOf('safari') > -1 && navigator.maxTouchPoints > 0))
    },
    curQuestionNumberTop() {
      const cur = this.curQuestion < 0 ? 0 : this.curQuestion - 1
      const nav = document.querySelector('.question-nav')
      const el = nav.querySelectorAll(this.mode == 'question' ? '.circle' : '.result')[cur]
      if (!el) return
      const pos = getChildOffsetRelativeToParent(el, nav)
      nav.scrollTop += pos.top - (this.mode == 'question' ? 20 : 15)
    },
    closeShowBigPhoto() { this.showBigPhotoSwitch = false },

    // ====================== 作答保存（唯一入口） ======================
    repariRecordQuestion(recordQuestion, limit = 0) {
      this.recordQuestionList[this.curQuestion] = JSON.parse(JSON.stringify(recordQuestion))
      this.questionList[this.curQuestion].limit = limit
      // this.saveAnswerCache()
    },

    urlToParent(img) {
      if (img) { this.showBigPhotoSwitch = true; this.imageUrl = img }
    },
    resetting() {
      const echo = this.convertType[this.form.type]
      const child = this.$refs[echo]
      child.resetting()
    },
    permissions(open) {
      this.nextQuestionSwitch = this.mode !== 'question' || open
    },
    clickTopic(key) {
      if (this.verifyFillExist() && !this.fillExistNotNumber.isSkip) {
        this.fillExistNotNumber = { methods: 'clickTopic', parmas: key, isSkip: false }
        return
      }
      if (clickQuestThrottle) return
      clickQuestThrottle = setTimeout(() => { clickQuestThrottle = null }, intervalTime)
      this.loading = true
      if (this.mode == 'question') this.getStudentAnswer()
      this.curQuestion = key
      this.questionList[this.curQuestion].status = '1'
      const nextForm = JSON.parse(JSON.stringify(this.questionList[this.curQuestion]))
      this.form = nextForm
      this.nextQuestionSwitch = this.mode !== 'question' || (nextForm.limit > 0)
      this.$nextTick(() => {
        this.loadCachedAnswerToComponent()
        this.loading = false
      })
      setTimeout(() => this.checkScroll(), 400)
    },
    prevQuestion() {
      this.loading = true
      this.curQuestion--
      this.questionList.forEach((item, idx) => {
        item.status = idx < this.curQuestion ? '2' : idx === this.curQuestion ? '1' : item.status
      })
      if (this.mode == 'question') this.getStudentAnswer()
      const nextForm = JSON.parse(JSON.stringify(this.questionList[this.curQuestion]))
      this.form = nextForm
      this.nextQuestionSwitch = this.mode !== 'question' || (nextForm.limit > 0)
      this.$nextTick(() => {
        this.loadCachedAnswerToComponent()
        this.loading = false
      })
      setTimeout(() => this.checkScroll(), 400)
    },
    skip() {
      if (this.curQuestion + 1 >= this.questionList.length) return
      this.loading = true
      if (this.mode == 'question') this.getStudentAnswer()
      this.curQuestion++
      this.questionList[this.curQuestion].status = '1'
      this.questionList[this.curQuestion].isRead = true
      const nextForm = JSON.parse(JSON.stringify(this.questionList[this.curQuestion]))
      this.form = nextForm
      this.nextQuestionSwitch = this.mode !== 'question' || (nextForm.limit > 0)
      this.$nextTick(() => {
        this.loadCachedAnswerToComponent()
        this.loading = false
      })
      setTimeout(() => this.checkScroll(), 400)
    },
    nextQuestion() {
      if (this.verifyFillExist() && !this.fillExistNotNumber.isSkip) {
        this.fillExistNotNumber = { methods: 'nextQuestion', parmas: null, isSkip: false }
        return
      }
      if (this.nextStatus === false) { this.isClickNext = true; return }
      if (this.nextStatus === true) { this.isClickNext = false; this.nextStatus = null }
      if (clickQuestThrottle) return
      clickQuestThrottle = setTimeout(() => { clickQuestThrottle = null }, intervalTime)
      this.loading = true
      if (this.mode == 'question') this.getStudentAnswer()
      this.curQuestion++
      this.questionList[this.curQuestion].status = '1'
      this.questionList[this.curQuestion].isRead = true
      const nextForm = JSON.parse(JSON.stringify(this.questionList[this.curQuestion]))
      this.form = nextForm
      this.nextQuestionSwitch = this.mode !== 'question' || (nextForm.limit > 0)
      this.$nextTick(() => {
        this.loadCachedAnswerToComponent()
        this.loading = false
      })
      setTimeout(() => this.checkScroll(), 400)
    },
    answerReview() {
      this.$nextTick(() => this.loadCachedAnswerToComponent())
    },
    completeBefore() {
      this.getStudentAnswer()
      const isEmpty = this.questionList.some(its => !its.limit || its.limit == 0)
      if (isEmpty) { this.confrimSwitch = true }
      else { if (this.isLoading) return; this.isLoading = true; this.complete() }
    },
    complete(a = 3) {
      this.confrimSwitch = false
      const { type, id, isSmallTest, gradeId, startTime } = this.$route.query
      let answer_results = JSON.parse(JSON.stringify(this.results.answer_results))
      const recordQuestionList = JSON.stringify(this.recordQuestionList)
      const ids = this.questionList.map(it => it.id)
      this.results.answer_results.forEach(it => {
        if (!ids.includes(it.id)) answer_results.push({ id: it.id, student_choices: [1] })
      })
      let t = 0
      if (type == 'assessments') t = 2
      else if (type == 'work') t = 3
      if (isSmallTest != null) t = isSmallTest == 'true' ? 1 : 0
      if (a != 3) return
      const data = {
        type: t,
        topic_id: this.results.topic_id,
        grade_id: gradeId,
        start_time: startTime,
        answer_results,
        recordQuestionList,
        questionListIds: ids,
        isSmallTest
      }
      const map = {
        assessments: [putAssessmentsAnswer, id],
        work: [putHomeworksAnswer, id],
        adventure: [putTopicsAnswer, id],
        library: [putPractisesAnswer, id]
      }
      const key = this.getType()
      if (!map[key]) return
      map[key][0](map[key][1], data).then(res => {
        this.isCompleted = true;
        this.clearAnswerCache();
        this.answerResults = res.data;
        this.completeSwitch = true;
        this.mode = 'viewAnswer';
        this.isLoading = false;
      }).catch(() => {
        this.isLoading = false;
      })
    },
    viewAnswer() {
      this.completeSwitch = false
      this.nextQuestionSwitch = true
      this.loading = true
      this.curQuestion = 0
      setTimeout(() => this.clickTopic(0), 200)
    },
    showAnswering() { this.answeringSwitch = true },
    showReference() { this.referenceSwitch = true },
    showIssues() { this.issuesSwitch = true },
    randomQuestionWord(res) {
      const _ = require('lodash')
      let data = _.shuffle(res.data.questions)
      const idx = Array.from({ length: data.length }, (_, i) => i).sort(() => Math.random() - 0.5)
      return idx.map(i => data[i])
    },
    randomQuestion(res) {
      const _ = require('lodash')
      let data = res.data.isRandom ? _.shuffle(res.data.questions) : res.data.questions
      if (res.data.isRandom && res.data.randomNumber > 0 && res.data.randomNumber < data.length) {
        const idx = _.sampleSize(_.range(data.length), res.data.randomNumber).sort((a, b) => a - b)
        data = idx.map(i => data[i])
      }
      return data
    },
    randomQuestionAssessments(res) { return res.data.questions },
    randomQuestionAdventure(res) {
      if (this.isSmallTest + '' === 'true') {
        const _ = require('lodash')
        let data = _.shuffle(res.data.questions)
        if (res.data.randomNumber > 0 && res.data.randomNumber < data.length) {
          const idx = _.sampleSize(_.range(data.length), res.data.randomNumber).sort((a, b) => a - b)
          data = idx.map(i => data[i])
        }
        return data
      } else {
        return res.data.questions
      }
    },
    handleExplanation(f) { f.explanation = (f.explanation || '').split('-----')[0] },
    defaultAddQuestion() {
      this.questionList.forEach((it, i) => {
        it.isRead = i === 0
        this.results.answer_results[i] = this.results.answer_results[i] || { id: it.id, student_choices: [] }
      })
    },
    isScrollSelf() {
      this.iscroll = new IScroll(this.$refs.wrapper, { mouseWheel: false, scrollbars: false, probeType: 3 })
    },
    getType() {
      const { type, isSmallTest } = this.$route.query
      if (isSmallTest != null) return isSmallTest + '' === 'true' ? 'adventure' : 'library'
      return type
    },

    // ====================== 初始化：正确顺序 ======================
    initData() {
      const { id, topicId } = this.$route.query
      this.results.topic_id = topicId || id
      const type = this.getType()
      const handler = {
        assessments() {
          getAssessments({ gradeId: this.$route.query.gradeId }).then(res => {
            let data = this.randomQuestionAssessments(res)
            data.forEach((it, i) => {
              it.status = i === 0 ? 1 : 0
              it.trueFlase = false
              it.key = i + 1
            })

            this.questionList = toSnakeCase(data)
            this.questionList.forEach(it => this.handleExplanation(it))
            this.form = JSON.parse(JSON.stringify(this.questionList[0]))
            delete res.data.questions
            this.questionInfo = res.data
            this.defaultAddQuestion()

            this.loadAllCache().then(() => {
              this.$nextTick(() => this.loadCachedAnswerToComponent())
            })
          })
        },
        work() {
          getHomeworksDetail(id).then(res => {
            let data = this.randomQuestionWord(res)
            data.forEach((it, i) => { it.status = i === 0 ? 1 : 0; it.trueFlase = false; it.key = i + 1 })
            this.questionList = toSnakeCase(data)
            this.questionList.forEach(it => this.handleExplanation(it))
            this.form = JSON.parse(JSON.stringify(this.questionList[0]))
            delete res.data.questions
            this.questionInfo = res.data
            this.defaultAddQuestion()
            this.loadAllCache().then(() => {
              this.$nextTick(() => this.loadCachedAnswerToComponent())
            })
          })
        },
        library() {
          getPractisesDetail(id).then(res => {
            let data = this.randomQuestion(res)
            data.forEach((it, i) => { it.status = i === 0 ? 1 : 0; it.trueFlase = false; it.key = i + 1 })
            this.questionList = toSnakeCase(data)
            this.questionList.forEach(it => this.handleExplanation(it))
            this.form = JSON.parse(JSON.stringify(this.questionList[0]))
            delete res.data.questions
            this.questionInfo = res.data
            this.defaultAddQuestion()
            this.loadAllCache().then(() => {
              this.$nextTick(() => this.loadCachedAnswerToComponent())
            })
          })
        },
        adventure() {
          getTopicsTest(id).then(res => {
            let data = this.randomQuestionAdventure(res)
            data.forEach((it, i) => { it.status = i === 0 ? 1 : 0; it.trueFlase = false; it.key = i + 1 })
            this.questionList = toSnakeCase(data)
            this.questionList.forEach(it => this.handleExplanation(it))
            this.form = JSON.parse(JSON.stringify(this.questionList[0]))
            delete res.data.questions
            this.questionInfo = res.data
            this.questionInfo.number = this.questionInfo.number || this.$t("studentProgramme.quiz")
            this.defaultAddQuestion()
            this.loadAllCache().then(() => {
              this.$nextTick(() => this.loadCachedAnswerToComponent())
            })
          })
        }
      }
      if (handler[type]) handler[type].call(this)
    },
    scrollUp() {
      const el = this.$refs.body
      if (!el) return
      const isTop = el.scrollTop <= 10
      if (isTop) return
      el.scrollBy({
        top: -130,
        behavior: 'smooth'
      })
      // 滚动完成后重新执行滚动判断
      this.checkScroll()
    },
    // 向下滚动
    scrollDown() {
      const el = this.$refs.body
      if (!el) return
      const bottom = el.scrollHeight - el.scrollTop <= el.clientHeight + 10
      if (bottom) return
      el.scrollBy({
        top: 130, // 每次下滚距离
        behavior: 'smooth'
      })
      // 滚动完成后重新执行滚动判断
      this.checkScroll()
    },
    toggleDrawingBoard() {
      this.showDrawingBoard = !this.showDrawingBoard
    },
    checkScroll() {
      const el = this.$refs.body
      if (!el) return
      const bottom = el.scrollHeight - el.scrollTop <= el.clientHeight + 10
      const fit = el.scrollHeight <= el.clientHeight
      // this.showMorePrompt = !bottom && !fit
      this.showMorePrompt = !fit
      this.showMoreImg = !bottom && !fit
    },
  },
  created() {
    this.skip = _throttle(this.skip, 750)
    this.childTransferStatus = () => {
      EventBus.$on('nextStatus', msg => this.nextStatus = msg)
    }
    this.childTransferStatus()
    this.initData()
  },
  mounted() {
    window.addEventListener('resize', this.checkScroll)
    setTimeout(() => this.checkScroll(), 2000)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScroll)
  }
}
</script>

<style scoped lang="scss">
.examination {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  .solid-btn {
    padding: 0 20px;
    height: 35px;
    line-height: 25px;
    border-radius: 18px;
    background-color: var(--bgc);
    color: var(--textc, #333);
    font-weight: 700;
    font-size: 16px;
    text-align: center;
    padding-top: 3px;
    position: relative;
    cursor: pointer;
    margin-left: 10px;
    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 18px;
      box-shadow: inset 0px -4px 1px 0 var(--bsc);
    }
    &:hover {
      opacity: .7;
    }
  }
  .header {
    width: 100%;
    height: 50px;
    background-color: #fff;
    padding: 0 20px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0px 2px 1px 0px rgba(0, 0, 0, 0.10);
    position: relative;
    .title {
      font-size: 16px;
    }
    .empty {
      height: 1px;
      width: 67px;
    }
  }
  .container {
    width: 100%;
    height: calc(100% - 50px);
    display: flex;
    background-color: #fff;
    .question-nav {
      width: 100px;
      height: 100%;
      background: #f6a053;
      padding: 20px;
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;
      .question-box {
        width: 100%;
        display: flex;
        justify-content: center;
        align-content: flex-start;
        flex-wrap: wrap;
        box-sizing: border-box;
      }
      .circle {
        width: 40px;
        height: 40px;
        background-color: #fcd8b5;
        color: #333;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        margin-bottom: 20px;
        font-weight: 700;
        &:before {
          content: '';
          position: absolute;
          width: 2px;
          height: 10px;
          background-color: #fff;
          bottom: -15px;
          left: 0;
          right: 0;
          margin: auto;
        }
      }
      .circle:nth-last-of-type(1) {
        &:before {
          content: none;
        }
      }
      .use-answer {
        background-color: #f46b40;
        color: #fff;
        &::before {
          background-color: #f46b40;
        }
      }
      .cur-answer {
        background-color: #e34f34;
        color: #fff;
      }
      .result {
        width: 40px;
        height: 40px;
        background-color: #f46b40;
        color: #fff;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        margin-bottom: 20px;
        font-weight: 700;
        box-shadow: 0 5px 1px 1px #d55c37;
      }
      .result:nth-last-of-type(1) {
        margin-bottom: 70px;
      }
      .cur-result {
        background-color: #e34f34;
        box-shadow: 0 5px 1px 1px #b84732;
      }
      .success {
        &:before {
          content: '';
          position: absolute;
          bottom: calc(100% - 20px);
          left: 100%;
          width: 20px;
          height: 20px;
          background-image: url('../../assets/images/circle-success.png');
          background-size: 100% 100%;
          border-radius: 50%;
        }
      }
      .error {
        &:before {
          content: '';
          position: absolute;
          bottom: calc(100% - 20px);
          left: 100%;
          width: 20px;
          height: 20px;
          background-image: url('../../assets/images/circle-error.png');
          background-size: 100% 100%;
          border-radius: 50%;
        }
      }
    }
    .quesion-main {
      height: 100%;
      padding: 20px 20px 10px 20px;
      box-sizing: border-box;
      overflow-y: auto;
      .main {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        .main-header {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 10px;
          .left {
            width: 100%;
            display: flex;
            align-items: center;
            .topic {
              color: #DE5934;
              font-weight: 700;
              margin-right: 15px;
            }
            .tip {
              margin-right: 10px;
              background-color: #ea6f57;
              color: #fff;
              padding: 7px 15px;
              border-radius: 5px;
            }
            .question-no {
              margin-right: 10px;
              color: #666;
              border-radius: 5px;
            }
          }
        }
        .body {
          flex: 1;
          width: 100%;
          background-color: #fff6ec;
          border-radius: 15px;
          position: relative;
          overflow-y: auto;
          box-sizing: border-box;
          .before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: #fff;
            z-index: 999;
          }
        }
        .viewAnswer-func {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 10px;
          div:nth-of-type(1) {
            font-weight: 700;
          }
          .reference {
            display: flex;
          }
        }
      }
    }
  }
  .filler-particle {
    width: 100%;
    height: 30px;
  }
}
.quesion-main {
  width: calc(100% - 100px);
}
.topic { font-size: 14px; }
.tip { font-size: 16px; }
.question-no { font-size: 16px; }
@media (max-width: 480px) {
  .question-nav { display: none; }
  .quesion-main { width: 100%; }
  .topic { font-size: 10px; }
  .tip { font-size: 8px; }
  .question-no { font-size: 8px; }
}
</style>
<style lang="scss">
.examination {
  .determine-success { border: 2px solid #007416 !important; position: relative !important; &:after { content: ''; position: absolute; top: 0; right: -40px; bottom: 0; margin: auto; width: 20px; height: 11px; border: 4px solid #007416; border-top: none; border-right: none; border-radius: 2px; transform: rotateZ(-45deg); } }
  .determine-error { border: 2px solid #d60215 !important; position: relative !important; &:after ,&:before { content: ''; position: absolute; top: 0; right: -40px; bottom: 0; margin: auto; background-color: #d60215; width: 20px; height: 4px; transform-origin: center center; transform: rotateZ(-45deg); border-radius: 20px; } &:before { transform: rotateZ(45deg); } }
  .determine-error-br { border: 2px solid #d60215 !important; position: relative !important; &:before { content: ''; position: absolute; bottom: -6px; right: -6px; width: 15px; height: 15px; border-radius: 50%; background-image: url('../../assets/images/circle-error.png'); background-size: 100% 100%; } }
  .determine-success-br { border: 2px solid #007416 !important; position: relative !important; &:before { content: ''; position: absolute; bottom: -6px; right: -6px; width: 15px; height: 15px; border-radius: 50%; background-image: url('../../assets/images/circle-success.png'); background-size: 100% 100%; } }
}
body{ overscroll-behavior-y: none; input { font-family: 'TimesNewRoman', sans-serif !important; } }
.more-prompt { position: fixed;
  bottom: 30px;
  right: 45%;
  z-index: 999; }
.up-down { position: fixed;
  bottom: 30px;
  right: 5%;
  z-index: 999; }
</style>